import { type ReactElement } from 'react'
import { Box, Group, Loader } from '@mantine/core'
import { Size } from '@front/model'
import styles from './table.module.css'

type Props = {
  span: number
  nested?: boolean
}

export const Loading = ({ span, nested = false }: Props): ReactElement => {
  if (nested) return <NestedLoading span={span} />
  return (
    <div
      className={styles.tableState}
      style={{
        gridColumn: `span ${span}`,
        padding: Size.space['4xl'],
      }}
    >
      <Loader />
    </div>
  )
}

// The table grid is as wide as every column (max-content, at least the viewport).
// Centering a loader in that full-span cell puts it at the midpoint of the whole
// table, not in the nested section under the expanded row. Stick it to the start
// of the visible section instead.
const NestedLoading = ({ span }: { span: number }): ReactElement => {
  return (
    <Group data-nested-loading justify='flex-start' style={{ gridColumn: `span ${span}` }} wrap='nowrap'>
      <Box left={0} pl='xl' pos='sticky' py='md'>
        <Loader size='sm' />
      </Box>
    </Group>
  )
}
